import Loadable from 'react-loadable';

export const UserManagerContainer = Loadable({
  loader: () => import('./UserManager'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/UserManager/index.ts